import { connect } from 'react-redux';
import { ApplicationState } from '../../../redux/reducers';
import Login from './Login';
import { login as signIn, storeSession, confirmSignUp } from '../../../redux/auth/creators';
interface StateProps {
  auth: any;
  showConfirmEmail: any;
}

interface DispatchProps {
  login: Function;
  storeSession: Function;
  confirmSignUp: Function;
}

interface OwnProps {}

export type AllProps = StateProps & DispatchProps & OwnProps;

const mapStateToProps = (state: ApplicationState) => {
  return {
    auth: state.auth,
    showConfirmEmail: state.auth.showConfirmEmail
  }
}

function mapDispatchToProps(dispatch: any): DispatchProps {
  return {
    login: dispatch(signIn),
    storeSession: dispatch(storeSession),
    confirmSignUp: dispatch(confirmSignUp),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Login);